import React, { useState } from "react";
import Confetti from "react-confetti";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Transition, TransitionGroup } from "react-transition-group";
import styled from "styled-components";
import Text from "~/components-shared/Text";
import Button from "~/components-shared/Button";
import { enterOnboardingComplete, exitOnboardingComplete } from "~/lib/animations";
import { Alert } from "~/components-shared";
import api from "~/lib/api";
import { handleError } from "~/lib/helpers";
import authActionCreators from "~/store/auth/actions";
import { resolveRouteFromAuthorities } from "~/lib/menu";
import jwtDecode from "jwt-decode";
import { useHistory } from "react-router-dom";
const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  backdrop-filter: blur(3px);
  z-index: 12;
  display: flex;
  align-items: center;
  justify-content: center;

  &:before {
    content: "";
    position: absolute;
    background-color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.background.secondary;
}};
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0.8;
  }
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
`;
const StyledText = styled(Text)`
  max-width: 500px;
`;
const SignUpOnboardingComplete = _ref2 => {
  let {
    open
  } = _ref2;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const history = useHistory();
  const onSubmit = () => {
    setLoading(true);
    api.onboardingComplete().then(_ref3 => {
      let {
        token
      } = _ref3;
      dispatch(authActionCreators.updateTokenStarted(token));
      const user = jwtDecode(token);
      history.replace(resolveRouteFromAuthorities(user.authorities));
    }).catch(e => {
      setError(handleError(e));
    }).finally(() => {
      setLoading(false);
    });
  };
  return /*#__PURE__*/React.createElement(TransitionGroup, {
    component: null
  }, /*#__PURE__*/React.createElement(Transition, {
    key: open,
    onEnter: node => enterOnboardingComplete(node),
    onExit: node => exitOnboardingComplete(node),
    timeout: {
      enter: 750,
      exit: 400
    },
    appear: true
  }, open ? /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Confetti, {
    width: window.innerWidth,
    height: window.innerHeight
  }), error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(Text, {
    element: "h2",
    fontSize: 20,
    className: "anim__complete-icon"
  }, "\uD83C\uDF89"), /*#__PURE__*/React.createElement(Text, {
    element: "h1",
    fontSize: 16,
    weight: "semiBold",
    s: {
      mb: 3
    },
    className: "anim__complete-title"
  }, t("OnboardingComplete.youAreSetUp")), /*#__PURE__*/React.createElement(StyledText, {
    element: "span",
    weight: "semiBold",
    fontSize: 5,
    lineHeight: 8,
    s: {
      mb: 3
    },
    className: "anim__complete-info"
  }, t("OnboardingComplete.description")), /*#__PURE__*/React.createElement(Button, {
    onClick: onSubmit,
    rounded: true,
    s: {
      mt: 6,
      px: 10,
      py: 6
    },
    fontSize: 6,
    className: "anim__complete-button",
    loading: loading,
    shadow: true
  }, t("OnboardingComplete.getStarted")))) : /*#__PURE__*/React.createElement("div", null)));
};
export default SignUpOnboardingComplete;